import { vn } from 'vend-number'
import { getInclusivePriceConsiderABP } from '../payments'
import { ReduxCurrentSale } from '../../state/slices/currentSale/currentSaleSlice'

/**
 * Evaluates the current sale and determines if the VCloud payment option should be disabled.
 *
 * @method shouldDisableVCloudPayment
 *
 * @param {Number | String} amountTendered
 * @param {Sale} sale
 *
 * @return {Boolean} True if the VCloud payment option should be disabled, false otherwise
 */
export const shouldDisableVCloudPayment = (
  amountTendered: number | string,
  sale: Pick<ReduxCurrentSale, 'payAccountBalance' | 'finals'>
): boolean => {
  // When Account Balance Payment(ABP) is added but not paid, should add it to total balance
  // to enable VCloud payment for both ABP and sale price
  const totalBal = getInclusivePriceConsiderABP(sale)

  return vn(amountTendered).gt(totalBal)
}
